import { CachePersistor } from 'apollo3-cache-persist';
import localForage from 'localforage';
import { InMemoryCache } from '@apollo/client';
import apolloPossibleTypes from '../../graphql/generated/apolloPossibleTypes';
import Logger from '../../utils/Logger';
import typePolicies from './typePolicies';

const CACHE_MAX_SIZE_MB = 100;
const CACHE_KEY = process.env.GRAPHQL_SCHEMA_HASH as string;

const localForageInstance = localForage.createInstance({
  name: 'slab-cache-persister-a3',
});

localForageInstance.keys().then((keys) => {
  keys.forEach((key) => {
    if (key !== CACHE_KEY) {
      localForageInstance.removeItem(key);
    }
  });
});

const cache = new InMemoryCache({
  possibleTypes: apolloPossibleTypes.possibleTypes,
  typePolicies,
});

class LocalForageWrapper {
  constructor(private storage: LocalForage) {}

  getItem(key: string): string | Promise<string | null> | null {
    return this.storage.getItem(key);
  }

  removeItem(key: string): void | Promise<void> {
    return this.storage.removeItem(key);
  }

  setItem(key: string, value: string): void | Promise<void> {
    return new Promise((resolve) => {
      this.storage
        .setItem(key, value)
        .then(() => resolve())
        .catch((err) => {
          Logger.warn(err);
          cachePersistor.remove();
        });
    });
  }
}

const cachePersistor = new CachePersistor({
  cache,
  debug: process.env.NODE_ENV !== 'production',
  key: CACHE_KEY,
  maxSize: CACHE_MAX_SIZE_MB * 1024 * 1024,
  storage: new LocalForageWrapper(localForageInstance),
});

export function purgeApolloCache() {
  cachePersistor.purge();
}

export async function tryRestore() {
  try {
    await cachePersistor.restore();
  } catch (error) {
    Logger.error(error);
  }
}

export default cache;
